export const VIEW_INVOICE_DETAIL_REQUEST = 'VIEW_INVOICE_DETAIL_REQUEST';
export const VIEW_INVOICE_DETAIL_SUCCESS = 'VIEW_INVOICE_DETAIL_SUCCESS';
export const VIEW_INVOICE_DETAIL_FAILED = 'VIEW_INVOICE_DETAIL_FAILED';

export const VIEW_INVOICE_DETAIL_ADD_COMMENT = 'VIEW_INVOICE_DETAIL_ADD_COMMENT';
export const VIEW_INVOICE_DETAIL_ADD_LINE_IMAGE = 'VIEW_INVOICE_DETAIL_ADD_LINE_IMAGE';
export const VIEW_INVOICE_DETAIL_REMOVE_LINE_IMAGE = 'VIEW_INVOICE_DETAIL_REMOVE_LINE_IMAGE';
export const VIEW_INVOICE_DETAIL_UPDATE_PICKUP_STATUS = 'VIEW_INVOICE_DETAIL_UPDATE_PICKUP_STATUS';
export const VIEW_INVOICE_DETAIL_UPDATE_ALL_LINE_STATUS = 'VIEW_INVOICE_DETAIL_UPDATE_ALL_LINE_STATUS';

export const SAVE_PICKUP_DETAIL_REQUEST_STARTED = 'SAVE_PICKUP_DETAIL_REQUEST_STARTED';
export const SAVE_PICKUP_DETAIL_REQUEST_SUCCESS = 'SAVE_PICKUP_DETAIL_REQUEST_SUCCESS';
export const SAVE_PICKUP_DETAIL_REQUEST_FAILED = 'SAVE_PICKUP_DETAIL_REQUEST_FAILED';



export const PICKUP_DETAIL_CLOSE_NOTIFICATION = 'PICKUP_DETAIL_CLOSE_NOTIFICATION';
export const PICKUP_DETAIL_OPEN_NOTIFICATION = 'PICKUP_DETAIL_OPEN_NOTIFICATION';

export const PICKUP_DETAIL_FORM_VALUE_CHANGE = 'PICKUP_DETAIL_FORM_VALUE_CHANGE';
export const PICKUP_DETAIL_CLOSE_SAVE_NOTIFICATION = 'PICKUP_DETAIL_CLOSE_SAVE_NOTIFICATION';
